// extracted by mini-css-extract-plugin
export default {"root":"Dashboard_root__VxYCh","card":"Dashboard_card__CXEjX","title":"Dashboard_title__4-wQy","router":"Dashboard_router__a4GIp","rootMobile":"Dashboard_rootMobile__s3UlM"};